module.exports = __webpack_public_path__ + "img/Pham.c4fc48e5.jpg";